import React, {useRef, useEffect, useState} from 'react';
import noImage from './images/no-image.png';
import './ImageWrapper.css';

function ImageWrapper({image, alt, display, width, height, errorWidth, errorHeight, errorPadding, margin, borderRadius, transition = true, loadDelay, onLoad, onMouseEnter, onMouseLeave}) {
    const imageRef = useRef(null);
    const [isLoadingImage, setIsLoadingImage] = useState(true);
    const [imageLoaded, setImageLoaded] = useState(false);
    const [usingErrorImage, setUsingErrorImage] = useState(false);

    useEffect(() => {
        const element = imageRef.current;
        element.onload = () => {
            setTimeout(() => {
                setIsLoadingImage(false);
                setImageLoaded(true);
                if (onLoad) onLoad();
            }, loadDelay * 1000);
        };
        element.onerror = () => {
            setTimeout(() => {
                setIsLoadingImage(false);
                setImageLoaded(false);
            }, loadDelay * 1000);
        };
        element.src = image;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        const element = imageRef.current;
        if (element) {
            if (!isLoadingImage && !imageLoaded) {
                element.src = noImage;
                setUsingErrorImage(true);
            } else if (!isLoadingImage && imageLoaded) {
                if (element.src !== noImage) setUsingErrorImage(false);
            }
        }
    }, [isLoadingImage, imageLoaded]);

    useEffect(() => {
        const element = imageRef.current;
        const newImage = image;
        const oldImage = element.src;
        if (newImage !== oldImage) {
            setIsLoadingImage(true);
            setTimeout(() => {element.src = newImage}, loadDelay * 1000);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [image]);

    const getSize = () => {
        if (usingErrorImage && (errorWidth || errorHeight)) return {width: errorWidth || 0, height: errorHeight || 0};
        else return {width: width, height: height};
    };

    const containerStyle = () => {
        const size = getSize();
        return {
            display: display,
            margin: margin || 'unset',
            padding: usingErrorImage && errorPadding ? errorPadding : 'unset',
            width: size.width || 30,
            height: size.height || 30,
            cursor: onMouseEnter && onMouseLeave ? 'pointer' : 'unset'
        };
    };

    const imageStyle = () => {
        const size = getSize();
        return {
            width: size.width || 30,
            height: size.height || 30,
            transform: `scale(${isLoadingImage ? 0 : 1})`,
            borderRadius: borderRadius || 0,
            transition: transition ? 'transform 0.2s ease, width 0.5s ease, height 0.5s ease' : 'unset'
        };
    };

    const handleMouseEnter = () => {
        if (onMouseEnter) onMouseEnter();
    };

    const handleMouseLeave = () => {
        if (onMouseLeave) onMouseLeave();
    };

    return (
        <div className='image-wrapper_container' style={containerStyle()} onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
            <img className='image-wrapper_image' ref={imageRef} alt={alt} style={imageStyle()} draggable={false}/>
        </div>
    );
}

export default ImageWrapper;